export enum CompanyMilestonesTooltipContentBlock {
  Root = 'CompanyMilestonesTooltipContent',
}
